module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-view/admin-view.component.css
// module id = ./src/app/components/admin/admin-view/admin-view.component.css
// module chunks = main